/* TacMed TMS Feature Comparison
   Shopify asset filename: tacmed-simulator-comparison.js
*/
(function () {
  "use strict";

  function initTacMedFeatureComparison() {
    var root = document.getElementById("tm-feature-comparison");
    if (!root || root.getAttribute("data-tmfc-initialized") === "true") return;

    var chipsEl = document.getElementById("tmfc-chips");
    var tableEl = document.getElementById("tmfc-table");
    var diffEl = document.getElementById("tmfc-diffonly");
    var tabs = document.querySelectorAll(".tmfc-tab");

    if (!chipsEl || !tableEl || !diffEl || !tabs.length) return;

    root.setAttribute("data-tmfc-initialized", "true");

    var DATA = {
      upper: {
        platforms: [
          { id: "matti", name: "MATTi™", tag: "Whole-Body Female" },
          { id: "crur", name: "CRU-R", tag: "Clinical Response" },
          { id: "aplpb", name: "APL-PB", tag: "AirwayPlus Lifecast" },
          { id: "tmu", name: "EMITT-TMU", tag: "Tactical Medical" },
          { id: "asu", name: "EMITT-ASU", tag: "Active Shooter" }
        ],
        groups: [
          {
            cat: "Airway & Breathing",
            rows: [
              ["Breathing", [1, 1, 1, 1, 0]],
              ["Realistic airway / intubation", [1, 1, 1, 1, 1]],
              ["Sensored intubation feedback", [1, 1, 1, 1, 0]],
              ["Physiologic response to bag ventilation", [1, 1, 1, 1, 0]],
              ["Difficult airway", [1, 1, 1, 0, 0]],
              ["Gastric rise with incorrect intubation", [1, 1, 1, 0, 0]],
              ["Cricothyroidotomy", [1, 1, 1, 1, 1]],
              ["NG tube placement", [1, 0, 0, 0, 0]],
              ["Nasal passage blockage", [1, 1, 1, 0, 0]],
              ["Teeth contact sensor", [1, 1, 1, 0, 0]]
            ]
          },
          {
            cat: "Chest Intervention",
            rows: [
              ["Tension pneumothorax", [1, 1, 0, 1, 0]],
              ["Needle decompression", [1, 1, 1, 1, 1]],
              ["Needle-D with air release", [1, 1, 1, 0, 0]],
              ["Bubbling chest wound", [1, 0, 1, 1, 1]],
              ["Bilateral chest tube", [1, 1, 1, 0, 0]]
            ]
          },
          {
            cat: "Circulation & Access",
            rows: [
              ["I/O trainer at manubrium (sternal)", [1, 1, 1, 1, 0]],
              ["I/O trainer at humeral head", [1, 1, 1, 1, 0]],
              ["IV training site", [1, 1, 1, 1, 1]],
              ["IV training site (infusible)", [0, 1, 1, 1, 1]],
              ["IV flash cue", [1, 1, 1, 1, 0]],
              ["Central line (subclavian)", [0, 1, 0, 0, 0]],
              ["IM injection sites — deltoid", [0, 1, 0, 0, 0]]
            ]
          },
          {
            cat: "Wounds & Trauma",
            rows: [
              ["Probeable wounds", [1, 1, 1, 1, 1]],
              ["Amputation arm with arterial bleeding", [2, 2, 2, 2, 0]],
              ["Burn arm", [0, 1, 2, 2, 2]]
            ]
          },
          {
            cat: "Assessment & Physiology",
            rows: [
              ["CPR with sensor feedback", [1, 1, 0, 0, 0]],
              ["Radial pulses", [1, 1, 1, 1, 0]],
              ["Carotid pulses", [1, 1, 1, 1, 0]],
              ["Brachial pulses", [0, 1, 0, 0, 0]],
              ["Blood pressure (standard cuff)", [0, 1, 0, 0, 0]],
              ["Heart and breath sounds", [0, 1, 1, 0, 0]],
              ["Adjustable eyes (manual)", [1, 0, 1, 1, 1]],
              ["Adjustable eyes (light-reactive)", [0, 1, 0, 0, 0]],
              ["Vital signs monitor / VitalsBridge compatible", [1, 1, 1, 1, 0]]
            ]
          },
          {
            cat: "Control & Feedback",
            rows: [
              ["Two-way audio communication", [1, 1, 1, 2, 0]],
              ["Ruggedised remote control", [1, 1, 1, 0, 0]],
              ["Real-time sensor feedback", [1, 1, 1, 1, 0]],
              ["Modular limbs", [1, 0, 0, 0, 0]]
            ]
          }
        ]
      },

      lower: {
        platforms: [
          { id: "matti", name: "MATTi™", tag: "Whole-Body Female" },
          { id: "crl", name: "CRL", tag: "Clinical Response" },
          { id: "hemo", name: "HEMO", tag: "Haemostatic" },
          { id: "hemog", name: "HEMO-G", tag: "Haemostatic GSW" },
          { id: "matt", name: "MATT", tag: "Dual Amputation" },
          { id: "tml", name: "EMITT-TML", tag: "Tactical Medical" },
          { id: "asl", name: "EMITT-ASL", tag: "Active Shooter" },
          { id: "nicl", name: "NICL", tag: "Non-Injured Clinical" }
        ],
        groups: [
          {
            cat: "Haemorrhage & Wounds",
            rows: [
              ["Amputation", [1, 1, 1, 1, 1, 1, 0, 0]],
              ["Bilateral leg amputations", [0, 0, 0, 0, 1, 0, 0, 0]],
              ["Packable inguinal crease wound", [1, 1, 1, 1, 0, 1, 1, 0]],
              ["Gunshot wound with arterial bleed", [0, 0, 0, 1, 0, 0, 1, 0]],
              ["Crushed leg with venous bleeding", [0, 0, 1, 0, 0, 0, 0, 0]],
              ["Non-bleeding crushed leg", [0, 2, 0, 2, 0, 2, 2, 0]],
              ["Scrotal avulsion", [0, 1, 1, 1, 1, 0, 0, 0]],
              ["Shrapnel", [0, 1, 1, 1, 1, 0, 0, 0]],
              ["Crepitus", [1, 1, 1, 1, 1, 1, 1, 0]]
            ]
          },
          {
            cat: "Access & Procedures",
            rows: [
              ["I/O trainer at the tibial head", [1, 1, 0, 0, 0, 1, 1, 0]],
              ["Foley catheter site with urine flow", [1, 1, 0, 0, 0, 0, 0, 0]],
              ["Intramuscular injection sites", [0, 1, 0, 0, 0, 0, 0, 0]]
            ]
          },
          {
            cat: "Assessment",
            rows: [
              ["Femoral pulses", [0, 1, 0, 0, 0, 0, 0, 0]],
              ["Pedal pulse", [1, 1, 0, 0, 0, 0, 0, 0]]
            ]
          },
          {
            cat: "Movement & Realism",
            rows: [
              ["Animatronic legs (powered motion)", [0, 1, 1, 1, 1, 0, 0, 0]],
              ["Prosthetic leg cover compatible", [0, 1, 1, 1, 0, 0, 0, 0]],
              ["Interchangeable male/female genitalia / priapism", [0, 1, 1, 1, 1, 0, 0, 0]],
              ["Modular limbs", [1, 0, 0, 0, 0, 0, 0, 0]]
            ]
          },
          {
            cat: "Control & Feedback",
            rows: [
              ["Ruggedised remote control", [1, 1, 1, 1, 1, 1, 1, 0]],
              ["Real-time sensor feedback", [1, 1, 1, 1, 1, 1, 1, 0]]
            ]
          }
        ]
      }
    };

    var state = {
      set: "upper",
      active: {},
      diffOnly: false
    };

    ["upper", "lower"].forEach(function (setName) {
      state.active[setName] = DATA[setName].platforms.map(function (platform) {
        return platform.id;
      });
    });

    function cell(value) {
      if (value === 1) {
        return '<span class="tmfc-yes" aria-label="Included">✓</span>';
      }

      if (value === 2) {
        return '<span class="tmfc-opt" aria-label="Optional">OPT</span>';
      }

      return '<span class="tmfc-no" aria-label="Not available">—</span>';
    }

    function renderChips() {
      var data = DATA[state.set];
      var active = state.active[state.set];

      chipsEl.innerHTML = "";

      data.platforms.forEach(function (platform) {
        var button = document.createElement("button");

        button.className = "tmfc-chip";
        button.type = "button";
        button.textContent = platform.name;
        button.setAttribute(
          "aria-pressed",
          active.indexOf(platform.id) > -1 ? "true" : "false"
        );

        button.addEventListener("click", function () {
          var index = active.indexOf(platform.id);

          if (index > -1) {
            if (active.length <= 2) return;
            active.splice(index, 1);
          } else {
            active.push(platform.id);
          }

          renderChips();
          renderTable();
        });

        chipsEl.appendChild(button);
      });
    }

    function renderTable() {
      var data = DATA[state.set];
      var active = state.active[state.set];
      var indexes = [];

      data.platforms.forEach(function (platform, index) {
        if (active.indexOf(platform.id) > -1) {
          indexes.push(index);
        }
      });

      var html = '<thead><tr><th scope="col">Feature</th>';

      indexes.forEach(function (index) {
        var platform = data.platforms[index];

        html +=
          '<th scope="col">' +
          platform.name +
          "<small>" +
          platform.tag +
          "</small></th>";
      });

      html += "</tr></thead><tbody>";

      data.groups.forEach(function (group) {
        var rows = "";

        group.rows.forEach(function (row) {
          var values = indexes.map(function (index) {
            return row[1][index];
          });

          if (
            state.diffOnly &&
            values.every(function (value) {
              return value === values[0];
            })
          ) {
            return;
          }

          rows +=
            "<tr><td>" +
            row[0] +
            "</td>" +
            values
              .map(function (value) {
                return "<td>" + cell(value) + "</td>";
              })
              .join("") +
            "</tr>";
        });

        if (rows) {
          html +=
            '<tr class="tmfc-cat"><td colspan="' +
            (indexes.length + 1) +
            '">' +
            group.cat +
            "</td></tr>" +
            rows;
        }
      });

      html += "</tbody>";
      tableEl.innerHTML = html;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        state.set = tab.getAttribute("data-set");

        tabs.forEach(function (otherTab) {
          otherTab.setAttribute(
            "aria-selected",
            otherTab === tab ? "true" : "false"
          );
        });

        renderChips();
        renderTable();
      });
    });

    diffEl.addEventListener("change", function () {
      state.diffOnly = diffEl.checked;
      renderTable();
    });

    renderChips();
    renderTable();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initTacMedFeatureComparison,
      { once: true }
    );
  } else {
    initTacMedFeatureComparison();
  }

  document.addEventListener(
    "shopify:section:load",
    initTacMedFeatureComparison
  );

  setTimeout(initTacMedFeatureComparison, 500);
})();